<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}">
						<h4 class="card-title" id="headof" (click)="back()"><i class="material-icons">arrow_left</i> Account Inquiry</h4>
					</div>
					<div class="card-body">
						<form [formGroup]="formGroup">
							<!-- Container-driven flex, NOT col-md-*. This component renders inside
							     nested containers that cost ~320px of sidebar plus padding, so
							     viewport-based Bootstrap breakpoints keep a multi-column layout
							     long after the component itself has run out of room. Each control
							     sizes off this row's own width instead. -->
							<div class="ai-filters">

								<!-- what you're looking at -->
								<div class="ai-f ai-f-acct">
									<app-gl-account-lookup (glselected)="selectGl($event)"></app-gl-account-lookup>
								</div>
								<div class="ai-f ai-f-range" *ngIf="!isDateMode()">
									<mat-form-field appearance="outline">
										<mat-label>From Period</mat-label>
										<mat-select formControlName="from_period" (selectionChange)="updateToOptions($event.value)">
											<mat-option *ngFor="let period of from_period_options" [value]="period.periodno">
												{{period.lastdate_in_period }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="ai-f ai-f-range" *ngIf="!isDateMode()">
									<mat-form-field appearance="outline">
										<mat-label>To Period</mat-label>
										<mat-select formControlName="to_period">
											<mat-option *ngFor="let period of to_period_options" [value]="period.periodno">
												{{period.lastdate_in_period }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="ai-f ai-f-range" *ngIf="isDateMode()">
									<mat-form-field appearance="outline">
										<mat-label>From Date</mat-label>
										<input matInput [matDatepicker]="fromDatePicker" formControlName="from_date">
										<mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
										<mat-datepicker #fromDatePicker></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="ai-f ai-f-range" *ngIf="isDateMode()">
									<mat-form-field appearance="outline">
										<mat-label>To Date</mat-label>
										<input matInput [matDatepicker]="toDatePicker" formControlName="to_date">
										<mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
										<mat-datepicker #toDatePicker></mat-datepicker>
									</mat-form-field>
								</div>

								<!-- how, plus actions -->
								<div class="ai-f ai-f-opt">
									<mat-form-field appearance="outline">
										<mat-label>Basis</mat-label>
										<mat-select formControlName="basis" (selectionChange)="onBasisChange()">
											<mat-option value="period">Period</mat-option>
											<mat-option value="date">Date</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="ai-f ai-f-opt">
									<mat-form-field appearance="outline">
										<mat-label>Posted</mat-label>
										<mat-select formControlName="posted">
											<mat-option *ngFor="let p of postedOptions" [value]="p.value">
												{{ p.label }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="ai-f ai-f-opt">
									<mat-form-field appearance="outline">
										<mat-label>GL Tag</mat-label>
										<mat-select formControlName="gl_tag">
											<mat-option *ngFor="let tag of tags" [value]="tag">
												{{ tag }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="ai-f ai-actions">
									<button mat-raised-button color="accent" (click)="getAccount()" [disabled]="formGroup.invalid">Run</button>
									<button mat-raised-button [matMenuTriggerFor]="menu" *ngIf="transresults.periods" [disabled]="!hasExportableRows">Export</button>
									<mat-menu #menu="matMenu">
										<button mat-menu-item (click)="exportExcel()" [disabled]="!hasExportableRows"><i class="fa fa-file-excel-o"></i> XLS</button>
										<button mat-menu-item (click)="exportPdf()"><i class="fa fa-file-pdf-o"></i> PDF </button>
									</mat-menu>
								</div>
							</div>
						</form>
						<!-- Grid toolbar: acts on rows already fetched, so it sits apart from the
						     query form above it. -->
						<div class="ai-grid-toolbar" *ngIf="periods_transactions && periods_transactions.length">
							<mat-form-field appearance="outline" class="ai-grid-filter">
								<mat-label>Filter</mat-label>
								<input matInput [(ngModel)]="filterText" [ngModelOptions]="{standalone: true}"
									(ngModelChange)="onFilterChange()"
									title="Matches type, number, date, amount, check, customer, description, tag">
								<button mat-icon-button matSuffix type="button" *ngIf="filterText"
									(click)="clearFilter()" aria-label="Clear filter">
									<i class="material-icons">close</i>
								</button>
							</mat-form-field>
							<mat-form-field appearance="outline" class="ai-grid-sort">
								<mat-label>Sort</mat-label>
								<mat-select [value]="sortKey" (selectionChange)="sortBy($event.value)">
									<mat-option value="">Ledger order</mat-option>
									<mat-option value="date">Date</mat-option>
									<mat-option value="type">Type</mat-option>
									<mat-option value="number">Number</mat-option>
									<mat-option value="debit">Debit</mat-option>
									<mat-option value="credit">Credit</mat-option>
									<mat-option value="balance">Balance</mat-option>
									<mat-option value="check">Check #</mat-option>
									<mat-option value="customer">Customer</mat-option>
									<mat-option value="desc">Description</mat-option>
									<mat-option value="tag">Tag</mat-option>
								</mat-select>
							</mat-form-field>
							<span class="ai-grid-meta">
								<button type="button" class="ai-spike-toggle" *ngIf="spikeCount"
									[class.is-on]="spikesOnly" (click)="toggleSpikesOnly()"
									[attr.aria-pressed]="spikesOnly"
									title="Show only outlier transactions">
									<i class="material-icons" aria-hidden="true">trending_up</i>{{ spikeCount }} spike{{ spikeCount === 1 ? '' : 's' }}
								</button>
								<span class="ai-grid-count">{{ shownCount | number }}/{{ totalCount | number }} rows</span>
								<span class="ai-grid-count" *ngIf="isFiltered()">Net {{ filteredNet | currency }}</span>
							</span>
							<button mat-icon-button type="button" (click)="toggleAllBands()" [disabled]="busy"
								[title]="allCollapsed ? 'Expand all periods' : 'Collapse all periods'"
								[attr.aria-label]="allCollapsed ? 'Expand all periods' : 'Collapse all periods'">
								<i class="material-icons" [class.is-spinning]="busy">{{ busy ? 'autorenew' : (allCollapsed ? 'unfold_more' : 'unfold_less') }}</i>
							</button>
							<button mat-stroked-button type="button" *ngIf="sortKey" (click)="clearSort()">Ledger order</button>
						</div>
						<div class="row" [class.ai-busy]="busy">
							<div class="col-md-12 text-center" *ngIf="isrunning">
								<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
									<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
									</circle>
								</svg>
							</div>
							<div class="col-md-12">
								<div class="table" id="acctrep" *ngIf="transresults">
									<h4 class="bold">Account Inquiry</h4>
									<h4>{{ selectedaccount.accountname }} ({{selectedaccount.accountcode}}) :
										Closing balance as of {{ getInquiryClosingLabel() }}: {{ transresults.endbalance | currency }}
									</h4>
									<p *ngIf="!isDateMode() && hasUnpostedBridgeRow() && formGroup.get('posted')?.value === 'all'" class="alert alert-info py-2 small mb-2">
										<strong>Unposted from prior periods</strong> &mdash; one net line for unposted GL dated before this range.
										To list it: Posted = Unposted, From period = fiscal year start.
									</p>
									<ng-container *ngIf="viewPeriods.length">
										<div class="table-responsive ai-table-wrap">
											<table class="table ai-table">
												<thead>
													<tr class="ai-col-header">
														<th class="col-type" [attr.aria-sort]="ariaSort('type')">
															<button class="sort-head" type="button" (click)="sortBy('type')">Type <i class="material-icons" aria-hidden="true">{{ sortIcon('type') }}</i></button>
														</th>
														<th class="col-number" [attr.aria-sort]="ariaSort('number')">
															<button class="sort-head" type="button" (click)="sortBy('number')">Number <i class="material-icons" aria-hidden="true">{{ sortIcon('number') }}</i></button>
														</th>
														<th class="col-date" [attr.aria-sort]="ariaSort('date')">
															<button class="sort-head" type="button" (click)="sortBy('date')">Date <i class="material-icons" aria-hidden="true">{{ sortIcon('date') }}</i></button>
														</th>
														<th class="col-amount" [attr.aria-sort]="ariaSort('debit')">
															<button class="sort-head" type="button" (click)="sortBy('debit')">Debit <i class="material-icons" aria-hidden="true">{{ sortIcon('debit') }}</i></button>
														</th>
														<th class="col-amount" [attr.aria-sort]="ariaSort('credit')">
															<button class="sort-head" type="button" (click)="sortBy('credit')">Credit <i class="material-icons" aria-hidden="true">{{ sortIcon('credit') }}</i></button>
														</th>
														<th class="col-check" [attr.aria-sort]="ariaSort('check')">
															<button class="sort-head" type="button" (click)="sortBy('check')">Check # <i class="material-icons" aria-hidden="true">{{ sortIcon('check') }}</i></button>
														</th>
														<th class="col-balance" [attr.aria-sort]="ariaSort('balance')" title="Running balance in ledger order">
															<button class="sort-head" type="button" (click)="sortBy('balance')">Balance <i class="material-icons" aria-hidden="true">{{ sortIcon('balance') }}</i></button>
														</th>
														<th class="col-customer" [attr.aria-sort]="ariaSort('customer')">
															<button class="sort-head" type="button" (click)="sortBy('customer')">Customer <i class="material-icons" aria-hidden="true">{{ sortIcon('customer') }}</i></button>
														</th>
														<th class="col-desc" [attr.aria-sort]="ariaSort('desc')">
															<button class="sort-head" type="button" (click)="sortBy('desc')">Description <i class="material-icons" aria-hidden="true">{{ sortIcon('desc') }}</i></button>
														</th>
														<th class="col-tag" [attr.aria-sort]="ariaSort('tag')">
															<button class="sort-head" type="button" (click)="sortBy('tag')">Tag <i class="material-icons" aria-hidden="true">{{ sortIcon('tag') }}</i></button>
														</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngFor="let transperiods of viewPeriods; let i = index; trackBy: trackBand">
														<tr class="ai-period-row" [class.ai-period-row-first]="i === 0" [class.is-spike]="transperiods.isspike">
															<td colspan="10" class="ai-period-cell">
																<div class="ai-period-label">
																	<button type="button" class="ai-period-toggle" (click)="toggleBand(transperiods)"
																		[attr.aria-expanded]="!transperiods.iscollapsed"
																		[title]="transperiods.iscollapsed ? 'Expand' : 'Collapse'">
																		<i class="material-icons" aria-hidden="true">{{ transperiods.iscollapsed ? 'chevron_right' : 'expand_more' }}</i>
																		<span class="ai-period-name">{{ periodLabel(transperiods) }}</span>
																		<span class="ai-period-rowcount" *ngIf="transperiods.iscollapsed">{{ transperiods.filteredcount | number }}</span>
																	</button>
																	<span class="ai-period-spike" *ngIf="transperiods.isspike" [title]="transperiods.spikereason">
																		<i class="material-icons" aria-hidden="true">trending_up</i>{{ transperiods.spikemultiple }}&times;
																	</span>
																	<span class="ai-period-spacer"></span>
																	<span class="ai-period-stat">
																		<span class="ai-period-stat-label">Open</span>
																		<span class="ai-period-stat-value">{{ transperiods.startbalance | currency }}</span>
																	</span>
																	<span class="ai-period-stat" *ngIf="hasPriorPeriodNet(transperiods)" [title]="'Net movement of ' + (transperiods.priorperiodlabel || 'the prior period') + ', same posted/tag scope'">
																		<span class="ai-period-stat-label">Prior</span>
																		<span class="ai-period-stat-value">{{ transperiods.priorperiodtotal | currency }}</span>
																	</span>
																	<span class="ai-period-stat">
																		<span class="ai-period-stat-label">Net</span>
																		<span class="ai-period-stat-value is-strong">{{ transperiods.periodtotal | currency }}</span>
																	</span>
																	<span class="ai-period-stat" *ngIf="transperiods.deltaprior !== null && transperiods.deltaprior !== undefined" [title]="'Change against ' + (transperiods.priorperiodlabel || 'the prior period')">
																		<span class="ai-period-stat-label">&Delta;</span>
																		<span class="ai-period-stat-value" [class.is-up]="transperiods.deltaprior > 0" [class.is-down]="transperiods.deltaprior < 0">{{ transperiods.deltaprior > 0 ? '+' : '' }}{{ transperiods.deltaprior | currency }}</span>
																	</span>
																	<span class="ai-period-stat" *ngIf="transperiods.runningnet !== null && transperiods.runningnet !== undefined" title="Cumulative net movement of this inquiry through the end of this period">
																		<span class="ai-period-stat-label">Running</span>
																		<span class="ai-period-stat-value">{{ transperiods.runningnet | currency }}</span>
																	</span>
																	<span class="ai-period-stat" *ngIf="isFiltered() || spikesOnly">
																		<span class="ai-period-stat-label">Filtered ({{ transperiods.filteredcount | number }})</span>
																		<span class="ai-period-stat-value">{{ transperiods.filteredtotal | currency }}</span>
																	</span>
																</div>
															</td>
														</tr>
														<ng-container *ngIf="!transperiods.iscollapsed">
															<tr *ngFor="let trans of transperiods.transactions; trackBy: trackRow"
																class="ai-data-row"
																(click)="openTransactionModal(trans, transperiods)"
																[class.clickable-row]="!(trans.adjustment_only === 1 || trans.adjustment_only === true)"
																[class.ai-adjustment]="trans.adjustment_only === 1 || trans.adjustment_only === true"
															[class.ai-row-is-spike]="trans.isspike">
																<td class="col-type" data-label="Type">{{ trans.type }}</td>
																<td class="col-number" data-label="Number">{{ trans.number }}</td>
																<td class="col-date" data-label="Date">{{ trans.trandate }}</td>
																<td class="col-amount" data-label="Debit">{{ +trans.debit ? (trans.debit | currency) : '' }}<span
																	class="ai-row-spike" *ngIf="trans.isspike && +trans.debit"
																	[title]="trans.spikereason">{{ trans.spikeshare }}%</span></td>
																<td class="col-amount is-credit" data-label="Credit">{{ +trans.credit ? (trans.credit | currency) : '' }}<span
																	class="ai-row-spike" *ngIf="trans.isspike && +trans.credit"
																	[title]="trans.spikereason">{{ trans.spikeshare }}%</span></td>
																<td class="col-check" data-label="Check #">{{ trans.chequeno || trans.check }}</td>
																<td class="col-balance" data-label="Balance" [class.is-negative]="+trans.balance < 0">{{ trans.balance | currency}}</td>
																<td class="col-customer" data-label="Customer" [title]="(trans.debtorno || '') + (trans.debtorno && trans.debtorname ? ' — ' : '') + (trans.debtorname || '')">
																	<ng-container *ngIf="trans.debtorno || trans.debtorname">
																		<span *ngIf="trans.debtorno">{{ trans.debtorno }}</span>
																		<span *ngIf="trans.debtorno && trans.debtorname"> — </span>
																		<span *ngIf="trans.debtorname">{{ trans.debtorname }}</span>
																	</ng-container>
																</td>
																<td class="col-desc" data-label="Description" [title]="trans.narrative">{{ trans.narrative }}</td>
																<td class="col-tag" data-label="Tag">{{ trans.tag }}</td>
															</tr>
														</ng-container>
													</ng-container>
												</tbody>
											</table>
										</div>
									</ng-container>
									<h4 class="text-left" *ngIf="isFiltered() && !viewPeriods.length && periods_transactions.length">No match in {{ totalCount | number }} rows</h4>
									<ng-container *ngIf="!periods_transactions.length && transresults">
										<h4 class="text-left"> No results</h4>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
